<script setup lang="ts">
interface TaglineProps {
  tagline?: string | null;
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
}

withDefaults(defineProps<TaglineProps>(), {
  as: 'h2',
});

const siteData = useState('siteData', () => useSiteData());
//get the logo_symbole
const logoSymbol = computed(() => siteData.value?.globals?.logo_symbole || '');
</script>

<template>
  <component
    :is="as"
    v-if="tagline"
    :class="`font-heading text-accent font-normal uppercase text-lg md:text-xl lg:text-tagline`"
  >
    <div class="inline-flex items-center">
      <DirectusImage
        :uuid="logoSymbol"
        :alt="tagline"
        class="inline-block w-6 h-6 mr-2"
        v-if="logoSymbol"
        style="filter: invert(33%) sepia(54%) saturate(476%) hue-rotate(0deg) brightness(95%) contrast(105%)"
      />

      <span class="inline-block">{{ tagline }}</span>
    </div>
  </component>
</template>
